import initialState from '../store/initialState'
import questionsTypes from '../constants/questionsTypes'

// const { toast } = window.M

export default function questionsReducer(state = initialState.questions, action) {
  switch (action.type) {

    case questionsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case questionsTypes.reset_question: {
      return {
        ...initialState.questions,
        items: state.items,
        question: state.question,
        audio_data: state.audio_data,
        audio_source: state.audio_source,
        image_data: state.image_data,
        image_source: state.image_source,
        pagination: state.pagination,
        totals: state.totals,
        filters: state.filters,
        sort: state.sort,
        order: state.order
      }
    }

    case "SET_PATH":
    case questionsTypes.clear_question: {
      if (action.type === "SET_PATH" && action.payload !== 'newquestion') {
        return {
          ...state
        }
      }
      return {
        ...initialState.questions,
        question: {
          answers: []
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
        filters: state.filters,
        sort: state.sort,
        order: state.order
      }
    }

    // GET
    case questionsTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case questionsTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        question: {
          ...action.payload
        },
        audio_data: {
          filename: action.payload.audio_file,
          length: action.payload.audio_length
        },
        image_data: {
          filename: action.payload.image_file,
        },
        errors: []
      }
    }

    case questionsTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case questionsTypes.update.request: {
      return {
        ...state,
        // fetching_single: true,
        // fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case questionsTypes.update.success: {
      return {
        ...state,
        // fetching_single: false,
        // fetched_single: true,
        must_redirect: true,
        errors: [],
        question: action.payload
      }
    }

    case questionsTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // UPLOAD AUDIO
    case questionsTypes.upload_audio.request: {
      return {
        ...state,
        errors: [],
        audio_data: {}
      }
    }

    case questionsTypes.upload_audio.success: {
      return {
        ...state,
        errors: [],
        audio_data: action.payload.audio_data
      }
    }

    case questionsTypes.upload_audio.failure: {
      return {
        ...state,
        errors: action.payload
      }
    }

    // version media
    case questionsTypes.version_media.request: {
      return {
        ...state,
        version_media: {},
        fetching_version_media: true,
      }
    }

    case questionsTypes.version_media.success: {
      const media_source = URL.createObjectURL(action.payload)
      return {
        ...state,
        version_media: {
          media_source: media_source
        },
        fetching_version_media: false,
      }
    }

    case questionsTypes.version_media.failure: {
      return {
        ...state,
        version_media: {},
        fetching_version_media: false,
      }
    }

    // DOWNLOAD AUDIO
    case questionsTypes.audio.request: {
      return {
        ...state,
        audio_source: null,
        fetching_audio: true,
      }
    }

    case questionsTypes.audio.success: {
      const audio_source = URL.createObjectURL(action.payload)
      return {
        ...state,
        audio_source: audio_source,
        fetching_audio: false
      }
    }

    case questionsTypes.audio.failure: {
      return {
        ...state,
        errors: action.payload,
        fetching_audio: false
      }
    }

    // UPLOAD IMAGE
    case questionsTypes.upload_image.request: {
      return {
        ...state,
        errors: [],
        image_data: {}
      }
    }

    case questionsTypes.upload_image.success: {
      return {
        ...state,
        errors: [],
        image_data: action.payload.image_data
      }
    }

    case questionsTypes.upload_image.failure: {
      return {
        ...state,
        errors: action.payload
      }
    }

    // DOWNLOAD IMAGE
    case questionsTypes.image.request: {
      return {
        ...state,
        image_source: null,
        fetching_image: true,
      }
    }

    case questionsTypes.image.success: {
      const image_source = URL.createObjectURL(action.payload)
      return {
        ...state,
        image_source: image_source,
        fetching_image: false
      }
    }

    case questionsTypes.image.failure: {
      return {
        ...state,
        errors: action.payload,
        fetching_image: false
      }
    }

    // INDEX
    case questionsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case questionsTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.questions,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case questionsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    //CSV
    case questionsTypes.csv.request: {
      return {
        ...state,
        fetching_csv: true,
        errors: []
      }
    }

    case questionsTypes.csv.success: {
      return {
        ...state,
        fetching_csv: false,
        errors: []
      }
    }

    case questionsTypes.csv.failure: {
      return {
        ...state,
        fetching_csv: false,
        errors: action.payload
      }
    }

    // duplicate question
    case questionsTypes.duplicate.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case questionsTypes.duplicate.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.questions,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case questionsTypes.duplicate.single:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        question: action.payload.question
      };
    }

    case questionsTypes.duplicate.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }

    // publish question
    case questionsTypes.publish.request:{
      return {
        ...state,
        setting_status: true,
        set_status: false
      };
    }

    case questionsTypes.publish.success:{
      return {
        ...state,
        setting_status: false,
        set_status: true,
        items: action.payload.questions,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      };
    }

    case questionsTypes.publish.single:{
      const {active, trash, versions, publisher} = action.payload.question
      return {
        ...state,
        setting_status: false,
        set_status: true,
        question: {
          ...state.question,
          active: active,
          trash: trash,
          versions: versions,
          publisher: publisher
        }
      };
    }


    case questionsTypes.publish.failure:{
      return {
        ...state,
        setting_status: false,
        set_status: false,
        errors: action.payload
      }
    }
    // LOCK = DISABLE, UNLOCK = ENABLE
    // case questionsTypes.lock.request: {
    //   return {
    //     ...state,
    //     fetching_single: true,
    //     fetched_single: false,
    //     errors: []
    //   }
    // }
    //
    // case questionsTypes.lock.success: {
    //   const {question}=action.payload
    //   return {
    //     ...state,
    //     fetching_single: false,
    //     fetched_single: true,
    //     errors: [],
    //     must_redirect: false,
    //     items: state.items.map( item => {
    //       if (item.id === question.id) {
    //         return question
    //       } else {
    //         return item
    //       }
    //     })
    //   }
    // }
    //
    // case questionsTypes.lock.failure: {
    //   return {
    //     ...state,
    //     fetching_single: false,
    //     fetched_single: false,
    //     errors: action.payload
    //   }
    // }
    //
    // DELETE
    case questionsTypes.destroy.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case questionsTypes.destroy.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: [],
        items: action.payload.questions,
        totals: action.payload.totals,
        pagination: action.payload.pagination
      }
    }

    case questionsTypes.destroy.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // CREATE
    // case questionsTypes.create.init: {
    //   return {
    //     ...state,
    //     fetching: false,
    //     fetched: false,
    //     must_redirect: false,
    //     errors: []
    //   }
    // }

    case questionsTypes.create.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        must_redirect: false,
        errors: []
      }
    }

    case questionsTypes.create.success: {
      // toast({
      //   html: "User created successfully"
      // })
      return {
        ...state,
        fetching: false,
        fetched: true,
        must_redirect: true,
        question: action.payload,
        errors: []
      }
    }

    case questionsTypes.create.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        must_redirect: false,
        errors: action.payload
      }
    }



    default: {
      return {...state};
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/reducers/questionsReducer.js